import type { FaireProductEntity } from "../../entity_types/product";

export const p_9c6kwv27qm: FaireProductEntity = {
  token: "p_9c6kwv27qm",
  type: "product",
  name: "More Than Butter Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/5b549877958799087366b35ec6c5ba3989be5caff696163c545a0c3bd7d05813.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8ef7d0aa275108be0204596c4ea692be27af020fe18654724e9a1ae3564c383e.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:03.245Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
